




import { createPopper, Instance, Modifier, OptionsGeneric } from "@popperjs/core";
import { Vue, Component, Prop } from "vue-property-decorator";

export interface PopupParams {
    text: string;
    isError?: boolean;
    maxWidth?: number;
}

@Component({})

export default class PopupExample extends Vue {
    @Prop() refElement: any;
    @Prop() params: PopupParams;

    localShow = false;
    popper: Instance | null = null;

    show() {
        this.localShow = true;
        this.renderPopup();
    }

    hide() {
        this.localShow = false;
        this.popper?.destroy()
        this.popper = null;
    }

    renderPopup() {
        this.$nextTick(() => {
            const $reference = this.refElement;
            const $tooltip = this.$el as HTMLElement;

            if ($reference && $tooltip) {
                const options: Partial<OptionsGeneric<Partial<Modifier<"offset" | "arrow", any>>>> = {
                    placement: "top",
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 5]
                            }
                        }
                    ]
                }

                this.popper = createPopper(
                    $reference,
                    $tooltip,
                    options
                )
            }
            else {
                throw new Error("$reference or $tooltip is not defined")
            }
        });
    }

    destroyed() {
        const el = this.$el;
        el?.parentNode?.removeChild(el);
    }

    get style() {
        return {
            maxWidth: this.params.maxWidth + 'px'
        }
    }

    get $s() {
        return this.$style
    }
}

